import { format } from 'date-fns';
import { Row, Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import CloseIcon from '~/images/icons/CloseIcon';

interface ISelectedDatePillProps {
  date: Date;
  onRemove: () => void;
}

export const SelectedDatePill = ({ date, onRemove }: ISelectedDatePillProps) => {
  return (
    <Row
      data-testid="selected-date-pill"
      data-cy="selected-date-pill"
      align="center"
      gap={2}
      style={{
        maxWidth: 190,
        backgroundColor: colors.primary[50],
        border: `1.5px solid ${colors.secondary[500]}`,
        borderRadius: 36,
        height: 38,
        padding: '0px 12px',
        animation: 'pillFadeIn 0.25s ease-out',
      }}
    >
      <Typography as="span" size="body_large" style={{ whiteSpace: 'nowrap', fontWeight: 400 }}>
        {format(date, 'EEE, MMM dd, yyyy')}
      </Typography>
      <Row
        data-testid="remove-date"
        data-cy="remove-date"
        onClick={onRemove}
        align="center"
        style={{ cursor: 'pointer' }}
      >
        <CloseIcon color={colors.secondary[500]} width={16} height={16} />
      </Row>
    </Row>
  );
};
